<i18n src="./resources/locales.json"></i18n>
<template>
  <EcsEndpointSelectionDialogPresentation
    ref="view"
    :private-phones="privatePhones"
    :endpoint-current-type="endpointCurrentType"
    :endpoint-current-destination="endpointCurrentDestination"
    :endpoint-default-destination="endpointDefaultDestination"
    @update-agent-endpoint="updateAgentEndpoint"
  />
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import EcsEndpointSelectionDialogPresentation from '@/components/ecs-endpoint-selection-dialog/EcsEndpointSelectionDialogPresentation';
import EcsEndPointSelectionMixin from '@/components/ecs-endpoint-selection-dialog/EcsEndPointSelectionMixin';
import AgentService from '@/services/agentService';

export default {
  name: 'EcsEndpointSelectionDialogContainer',

  components: {
    EcsEndpointSelectionDialogPresentation
  },

  mixins: [EcsEndPointSelectionMixin],

  data() {
    return {
      agentId: null,
      privatePhones: [],
      endpointDefaultDestination: ''
    };
  },

  computed: {
    ...mapGetters('AGENT', ['loggedInAgent']),

    endpointCurrentType() {
      return this.loggedInAgent.currentExtension ? this.loggedInAgent.currentExtension.terminalType : 'HPBXPhone';
    },

    endpointCurrentDestination() {
      return this.loggedInAgent.currentExtension
        ? this.loggedInAgent.currentExtension.terminalURI
        : this.loggedInAgent.hpbxExtension;
    }
  },

  created() {
    this.agentId = this.loggedInAgent.id;
    this.privatePhones = this.loggedInAgent.terminals;
    this.endpointDefaultDestination = this.loggedInAgent.hpbxExtension;

    this.$root.$on('ecs-endpoint-selection-dialog-open', this.open);
  },

  beforeDestroy() {
    this.$root.$off('ecs-endpoint-selection-dialog-open', this.open);
  },

  methods: {
    ...mapActions('AGENT', ['setAgentCurrentExtension']),

    ...mapActions('SETTINGS', ['updateLastSelectedTerminal']),

    ...mapActions('EVENT_TIMING', [
      'addEventTimingConstraintForAgentTerminal',
      'removeEventTimingConstraintForAgentTerminal',
      'clearAllEventTimingConstraints'
    ]),

    updateAgentEndpoint(endpoint) {
      try {
        const terminal = this.convertEndpointToEcsFormat(endpoint);
        const agent = JSON.parse(sessionStorage.getItem('agent'));
        const browserId = sessionStorage.getItem('AWC_BROWSER_ID');

        this.addEventTimingConstraintForAgentTerminal({ agentId: this.loggedInAgent && this.loggedInAgent.id });

        if (this.loggedInAgent.isSupervisor) {
          AgentService.selectTerminal({
            agentId: this.loggedInAgent.id,
            instanceId: browserId,
            terminal: terminal.terminalType === 'InternalPhone' ? '' : terminal.terminalURI
          }).then(() => {
            this.updateLastSelectedTerminal(terminal);
          });
        } else {
          this.$root.$emit('register', {
            account: agent.account,
            terminal,
            callback: () => {
              this.updateLastSelectedTerminal(terminal);
            }
          });
        }
      } catch (error) {
        if (this.loggedInAgent) {
          this.removeEventTimingConstraintForAgentTerminal({ agentId: this.loggedInAgent.id });
          this.$root.$emit('snackbar-message', {
            message: this.$t('saveError'),
            type: 'error'
          });
        } else {
          this.clearAllEventTimingConstraints();
        }
      }
    },

    async open(event) {
      this.agentId = this.loggedInAgent.id;
      this.privatePhones = this.loggedInAgent.terminals;
      this.endpointDefaultDestination = this.loggedInAgent.hpbxExtension;
      await this.$nextTick();
      this.$refs.view.open(event);
    }
  }
};
</script>
